import React, { useEffect, useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, Smartphone } from "lucide-react";

const VIDEO_SRC = "/videos/hero.mp4";
const VIDEO_POSTER = "/videos/hero-poster.jpg";

// Full-screen corporate video player, opened from the hero play button.
export default function VideoLightbox({ open, onClose }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    window.__lenis?.stop();
    document.documentElement.classList.add("overflow-hidden");
    return () => {
      window.removeEventListener("keydown", onKey);
      window.__lenis?.start();
      document.documentElement.classList.remove("overflow-hidden");
      videoRef.current?.pause();
    };
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
          data-testid="video-lightbox"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0A1628]/90 backdrop-blur-md p-4 md:p-10"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 12 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-5xl"
          >
            <video
              ref={videoRef}
              src={VIDEO_SRC}
              poster={VIDEO_POSTER}
              controls
              autoPlay
              playsInline
              preload="metadata"
              data-testid="hero-video-player"
              className="w-full aspect-video rounded-md shadow-2xl shadow-black/50 bg-black"
            />
            <p
              data-testid="video-rotate-hint"
              className="md:hidden mt-4 flex items-center justify-center gap-2 text-xs text-white/70 font-medium uppercase tracking-widest"
            >
              <Smartphone className="w-4 h-4 rotate-90" />
              Gira el móvil para verlo mejor
            </p>
            <button
              type="button"
              onClick={onClose}
              data-testid="video-lightbox-close"
              aria-label="Cerrar vídeo"
              className="absolute -top-3 -right-3 md:-top-4 md:-right-4 flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#0A1628] shadow-xl transition-transform duration-200 hover:scale-110"
            >
              <X className="w-5 h-5" />
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
